import { Component, OnInit, Input, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'pds-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss']
})
export class MenuListComponent implements OnInit {

  @Input() itemList: Array<any>;

  @Output() dataItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();

  @ContentChild('menuBack', {static: false}) menuBackTextTemplateRef: TemplateRef<any>;
  @ContentChild('menuTitle', {static: false}) menuTitleTemplateRef: TemplateRef<any>;

  public currentIndex: number = -1;

  constructor() { }

  ngOnInit(): void {
  }

  getDataItem(itemId, index){
    this.dataItem.emit(itemId);
    this.currentIndex = index;
  }

  closeMenu(){
    this.closed.emit();
  }

}
